import colors from "core/resources/theme/colors";
import Button, { ButtonProps } from ".";

interface SelectableButtonProps extends ButtonProps {
  selected: boolean;
  onUnselect?: () => any;
  selectedColor?: string;
  unSelectColor?: string;
  variant?: "outline" | "fill";
  size?: "sm" | "lg";
}

function SelectableButton({
  children,
  selected,
  onUnselect,
  onClick,
  disabled,
  selectedColor = colors.blue,
  unSelectColor = colors.white,
  variant = "fill",
  size = "lg",
  ...rest
}: SelectableButtonProps) {
  return variant === "fill" ? (
    <Button
      rounded={4}
      px={size === "lg" ? 4 : 2}
      py={size === "lg" ? 0 : 2}
      h={size === "lg" ? "35px" : "20px"}
      bgColor={selected ? selectedColor : unSelectColor}
      color={selected ? colors.white : colors.black}
      borderColor={selected ? selectedColor : colors.black}
      borderWidth="1px"
      display="flex"
      fontWeight="normal"
      gridGap={2}
      fontSize={"12px"}
      _hover={{
        opacity: disabled ? 0.6 : 0.8,
      }}
      _disabled={{
        opacity: 0.3,
      }}
      onClick={selected ? onUnselect : onClick}
      {...rest}
    >
      {children}
    </Button>
  ) : (
    <Button
      rounded={4}
      px={2}
      py={2}
      h="20px"
      bgColor={selected ? selectedColor : unSelectColor}
      color={selected ? colors.white : colors.black}
      borderColor={selected ? selectedColor : colors.black}
      borderWidth="1px"
      display="flex"
      fontWeight="normal"
      gridGap={2}
      fontSize={"12px"}
      _hover={{
        opacity: disabled ? 0.6 : 0.8,
      }}
      _disabled={{
        opacity: 0.3,
      }}
      onClick={selected ? onUnselect : onClick}
      {...rest}
    >
      {children}
    </Button>
  );
}

export default SelectableButton;
